const utils = require('frontend-controller/lib/utils')

module.exports = {
	model: {
		mailingListAdditionalFieldLookUp: {},
		initScrollTop: 0
	},

	events: {
		delete: {
			type: 'click',
			selector: 'td.delete',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $button = $(event.target).closest('td.delete');
				var segmentID = $button.closest('tr').data('segmentId');
				if (segmentID) {
					self.closest('templates_newsletter_segments_controller', function(controllerComponent){
						controllerComponent.deleteSegment(segmentID).then(function(){
							self.refreshSegmentCount();
						})
					});
				}
			}
		},
		create: {
			type: 'click',
			selector: 'button.addSegment',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $button = $(event.target);

				var mailingListID = $button.data('mailingListId');
				var additionalDataComponentID = $button.data('additionalDataComponentId');

				if (mailingListID) {
					self.closest('templates_newsletter_segments_controller', function(controllerComponent){
						controllerComponent.createSegment((self.model.mailingListAdditionalFieldLookUp[mailingListID] || {}), mailingListID, additionalDataComponentID);
					});
				}
			}
		},
		edit: {
			type: 'click',
			selector: 'td.edit',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $button = $(event.target).closest('td.edit');
				if($button.length > 0){
					var segmentID = $button.closest('tr').data('segmentId');
					if(segmentID){
						self.closest('templates_newsletter_segments_controller', function(controllerComponent){
							var $tbody = $button.closest('tbody');
							var mailingListID = $tbody.data('mailingListId');
							var additionalDataComponentID = $tbody.data('additionalDataComponentId');
							controllerComponent.editSegment(segmentID, (self.model.mailingListAdditionalFieldLookUp[mailingListID] || {}), additionalDataComponentID);
						});
					}
				}
			}
		},
		refresh: {
			type: 'click',
			selector: 'td.refresh',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $button = $(event.target).closest('td.refresh');
				if($button.length > 0){
					var segmentID = $button.closest('tr').data('segmentId');
					if(segmentID){
						self.model.initScrollTop = self.$.scrollTop();
						self.refreshSegmentCount(segmentID);
						var statusController;
						if((statusController = getComponent('statusController'))) {
							statusController.addPanel('status.done.refresh');
						}
					}
				}
			}
		}
	},

	methods: {

		sanitizeResources: function(){
			var entry, i, j, additionalData;
			if (this.resourceData.additionalFieldsOfMailingLists) {
				this.model.mailingListAdditionalFieldLookUp = {};

				for(i in (this.resourceData.additionalFieldsOfMailingLists || {}).data || []){
					entry = this.resourceData.additionalFieldsOfMailingLists.data[i].attributes;
					if (!this.model.mailingListAdditionalFieldLookUp[entry.mailingListID]) this.model.mailingListAdditionalFieldLookUp[entry.mailingListID] = {};
					additionalData = (((entry.cms_component || {}).cpTpl || {}).tplAtoms || []);
					if (additionalData.length > 0) {
						for(j in additionalData) {
							this.model.mailingListAdditionalFieldLookUp[entry.mailingListID]['a_' + additionalData[j].fieldCode] = {
								name: 		additionalData[j].cms_templatesAtomsTrl[0].label,
								dataType:	additionalData[j].tplAtom.dataType,
								renderType:	additionalData[j].tplAtom.renderType
							};
						}
					}
				}
			}
		},
		refreshSegmentCount: function(segmentID){
			var self = this;
			var promise = utils.promise.resolve();
			if(segmentID){
				promise = self.performAction(
					self.prepareAction('refreshSegmentCount', segmentID)
				);
			}

			return promise.then(function(context){
				self.furthest('base_tabStrip_tabStrip', undefined, function(tabStrip){
					tabStrip.find('templates_newsletter_mailings_mailings', function(mailings) {
						mailings.afterRefreshSegmentCounts();
					});
				});
				self.refresh();
				return utils.promise.resolve();
			});
		},

		refreshData: function(){
			this.model.initScrollTop = this.$.scrollTop();
			this.refresh();
		}
	},

	hooks: {
		attach: function($element, options){
			if(options.refresh && this.model.initScrollTop){
				this.$.scrollTop(this.model.initScrollTop);
				this.model.initScrollTop = 0;
			}
		}
	}
}